module.exports = ":host {\n  display: block;\n  padding: 8px;\n  background: #263238;\n  cursor: text;\n  overflow: auto; }\n"